import React, { useCallback, useEffect, useState } from 'react';
import { Star, Search, Smartphone, ShieldCheck, Eye, BadgeCheck, ChevronLeft, ChevronRight } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const testimonials = [{
  quote: 'La verdad no esperaba mucho, pero en menos de 3 días ya tenía mi página corriendo. La primera semana me llegaron 4 llamadas de Google. Por $250 fue la mejor decisión que tomé para mi negocio.',
  author: 'Marcus Thompson',
  role: 'Tree Service',
  location: 'Austin, TX',
  avatar: 'https://randomuser.me/api/portraits/men/32.jpg',
  timeAgo: 'hace 2 semanas'
}, {
  quote: 'Mi trabajo siempre fue bueno pero mi página vieja me daba pena enseñarla. Ahora los clientes llegan con más confianza y hasta me preguntan menos por el precio. Muy contento con el resultado.',
  author: 'Roberto Mendoza',
  role: 'Roofing & Repairs',
  location: 'Houston, TX',
  avatar: 'https://randomuser.me/api/portraits/men/65.jpg',
  timeAgo: 'hace 1 mes'
}, {
  quote: 'Pensé que un website así iba a costar miles. Pagué $250 y en 72 horas tenía algo que se ve mejor que el de mi competencia que tardó meses. La comunicación por WhatsApp fue rapidísima.',
  author: 'Carlos Díaz',
  role: 'General Contractor',
  location: 'Phoenix, AZ',
  avatar: 'https://randomuser.me/api/portraits/men/76.jpg',
  timeAgo: 'hace 3 semanas'
}, {
  quote: 'El plan de $30 al mes vale cada centavo. Cada vez que termino un proyecto nuevo les mando las fotos y me las suben el mismo día. Atención de primera, los recomiendo 100%.',
  author: 'James Rivera',
  role: 'Landscaping',
  location: 'Dallas, TX',
  avatar: 'https://randomuser.me/api/portraits/men/52.jpg',
  timeAgo: 'hace 5 días'
}, {
  quote: 'Lo que más me sorprendió fue que a mis propios clientes les encantó la página. Varios me dijeron "qué profesional se ve tu negocio". Eso me dio mucha más credibilidad para cerrar trabajos grandes.',
  author: 'Andrés Castillo',
  role: 'Pressure Washing',
  location: 'Orlando, FL',
  avatar: 'https://randomuser.me/api/portraits/men/41.jpg',
  timeAgo: 'hace 1 semana'
}, {
  quote: 'Le pusimos el QR de la página en las camionetas y ahora es publicidad gratis rodando por toda la ciudad. La gente escanea el código en los semáforos y nos escriben directo por WhatsApp. Genial.',
  author: 'Luis Hernández',
  role: 'HVAC & Plomería',
  location: 'San Antonio, TX',
  avatar: 'https://randomuser.me/api/portraits/men/85.jpg',
  timeAgo: 'hace 2 semanas'
}, {
  quote: 'En la primera semana ya tenía gente preguntando por presupuestos desde la página. Antes andaba pegando flyers y ahora los clientes me encuentran solos. Valió cada dólar de los $250.',
  author: 'Miguel Ángel Soto',
  role: 'Construcción',
  location: 'Las Vegas, NV',
  avatar: 'https://randomuser.me/api/portraits/men/64.jpg',
  timeAgo: 'hace 4 días'
}];
const stats = [{
  icon: Search,
  data: '97%',
  desc: 'de los consumidores busca online antes de contratar',
  meaning: 'Tus clientes te están buscando ahora mismo'
}, {
  icon: Eye,
  data: '75%',
  desc: 'nunca pasa de la primera página de Google',
  meaning: 'Si no estás ahí, no existes'
}, {
  icon: Smartphone,
  data: '88%',
  desc: 'de los que buscan en celular contactan en 24 horas',
  meaning: 'Presencia móvil = clientes inmediatos'
}, {
  icon: ShieldCheck,
  data: '3x',
  desc: 'más confianza generan los websites profesionales',
  meaning: 'Véte premium, consigue clientes premium'
}];
export function TestimonialsSection() {
  const [index, setIndex] = useState(0);
  const [direction, setDirection] = useState(1);
  const goTo = useCallback((next: number) => {
    setDirection(next > index ? 1 : -1);
    setIndex((next + testimonials.length) % testimonials.length);
  }, [index]);
  const prev = () => {
    setDirection(-1);
    setIndex(i => (i - 1 + testimonials.length) % testimonials.length);
  };
  const next = () => {
    setDirection(1);
    setIndex(i => (i + 1) % testimonials.length);
  };
  // Auto-advance
  useEffect(() => {
    const timer = setInterval(() => {
      setDirection(1);
      setIndex(i => (i + 1) % testimonials.length);
    }, 6000);
    return () => clearInterval(timer);
  }, []);
  const test = testimonials[index];
  return <section id="resenas" className="py-24 bg-dark-100" data-id="element-423" data-mp="1uwtpnwinslzy">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-424" data-mp="1zubp8wasdova">
        <div className="text-center mb-12" data-id="element-425" data-mp="1kwt403xbhtsl">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-426" data-mp="1kxugmctzeocf">
            Los Contractors Que Dieron El Paso{' '}
            <br className="hidden md:block" data-id="element-427" data-mp="1px7cfn2tz5r5" />
            <span className="text-gold" data-id="element-428" data-mp="3fbdjm26s6z54">No Se Arrepienten</span>
          </h2>
          <div className="inline-flex items-center gap-3 bg-dark px-5 py-2.5 rounded-full border border-white/10" data-id="element-429" data-mp="3k9x7i84xql04">
            <div className="flex gap-0.5" data-id="element-430" data-mp="18la52vrlyx1s">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-gold text-gold" data-id="element-431" data-mp="13nqin8krbdyr" data-mpi={i} />)}
            </div>
            <span className="text-white font-bold text-sm" data-id="element-432" data-mp="1ic4sw4ki64pc">4.9 / 5</span>
            <span className="text-gray-500 text-sm" data-id="element-433" data-mp="1dleqn07dihyv">· +120 reseñas</span>
          </div>
        </div>

        {/* Carousel */}
        <div className="max-w-2xl mx-auto mb-24" data-id="element-434" data-mp="1rbrv2sl23ejg">
          <div className="relative flex items-center" data-id="element-435" data-mp="1ree4yyvf664u">
            {/* Prev button */}
            <button onClick={prev} aria-label="Reseña anterior" className="hidden sm:flex absolute -left-4 lg:-left-16 z-20 w-12 h-12 items-center justify-center rounded-full bg-dark border border-white/10 text-gray-400 hover:text-gold hover:border-gold/40 transition-colors" data-id="element-436" data-mp="1naof8630dii8">
              <ChevronLeft className="w-6 h-6" data-id="element-437" data-mp="1xv5bco34jzk" />
            </button>

            {/* Card */}
            <div className="relative w-full overflow-hidden min-h-[340px]" data-id="element-438" data-mp="21zut7nt3izi3">
              <AnimatePresence mode="wait" custom={direction} data-id="element-439" data-mp="221xskyg524zh">
                <motion.div key={index} custom={direction} initial={{
                opacity: 0,
                x: direction * 60
              }} animate={{
                opacity: 1,
                x: 0
              }} exit={{
                opacity: 0,
                x: direction * -60
              }} transition={{
                duration: 0.4,
                ease: 'easeOut'
              }} className="bg-dark p-8 rounded-2xl border border-white/10 relative" data-id="element-440" data-mp="26zqtpd2l48sw">
                  {/* Header: avatar + name + verified */}
                  <div className="flex items-center gap-4 mb-5" data-id="element-441" data-mp="33n3x1ejbh3wf">
                    <img src={test.avatar} alt={test.author} className="w-14 h-14 rounded-full object-cover border-2 border-gold/30" data-id="element-442" data-mp="38p2z8l3blurs" />
                    <div className="flex-1 min-w-0" data-id="element-443" data-mp="3dru2vvhucs5x">
                      <div className="flex items-center gap-1.5" data-id="element-444" data-mp="38tiu7o3a8npa">
                        <p className="text-white font-bold truncate" data-id="element-445" data-mp="38vvh8fnwdo97">
                          {test.author}
                        </p>
                        <BadgeCheck className="w-4 h-4 text-gold shrink-0" data-id="element-446" data-mp="5dlg54202vlo" />
                      </div>
                      <p className="text-gray-500 text-sm truncate" data-id="element-447" data-mp="fa5ws7smj2x">
                        {test.role} · {test.location}
                      </p>
                    </div>
                  </div>

                  <div className="flex items-center justify-between mb-4" data-id="element-448" data-mp="3nq9tlxcyhzew">
                    <div className="flex gap-0.5" data-id="element-449" data-mp="o3l2vkadbylx">
                      {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-gold text-gold" data-id="element-450" data-mp="jcl2u65yd0f7" data-mpi={i} />)}
                    </div>
                    <span className="text-gray-600 text-xs" data-id="element-451" data-mp="130dcfhfk0uak">
                      {test.timeAgo}
                    </span>
                  </div>

                  <p className="text-gray-300 leading-relaxed text-lg" data-id="element-452" data-mp="t2z98jin6207">
                    {test.quote}
                  </p>

                  <p className="mt-5 pt-4 border-t border-white/5 text-xs text-gray-600 flex items-center gap-1.5" data-id="element-453" data-mp="y194sv8a34mc">
                    <BadgeCheck className="w-3.5 h-3.5 text-gold/60" data-id="element-454" data-mp="1lsy26pzyija5" />
                    Cliente verificado de AS Elite Contractor
                  </p>
                </motion.div>
              </AnimatePresence>
            </div>

            {/* Next button */}
            <button onClick={next} aria-label="Siguiente reseña" className="hidden sm:flex absolute -right-4 lg:-right-16 z-20 w-12 h-12 items-center justify-center rounded-full bg-dark border border-white/10 text-gray-400 hover:text-gold hover:border-gold/40 transition-colors" data-id="element-455" data-mp="1gsa0nae3qk1o">
              <ChevronRight className="w-6 h-6" data-id="element-456" data-mp="2jjunufe5crkf" />
            </button>
          </div>

          {/* Mobile arrows + dots */}
          <div className="flex items-center justify-center gap-6 mt-8" data-id="element-457" data-mp="2elt2fnt90g5s">
            <button onClick={prev} aria-label="Reseña anterior" className="sm:hidden w-10 h-10 flex items-center justify-center rounded-full bg-dark border border-white/10 text-gray-400 hover:text-gold transition-colors" data-id="element-458" data-mp="2skj47gr0j40h">
              <ChevronLeft className="w-5 h-5" data-id="element-459" data-mp="1vwcsk9vobbcp" />
            </button>

            <div className="flex gap-2" data-id="element-460" data-mp="29mybtzp1hnb4">
              {testimonials.map((_, i) => <button key={i} onClick={() => goTo(i)} aria-label={`Ir a la reseña ${i + 1}`} className={`h-2.5 rounded-full transition-all ${i === index ? 'w-8 bg-gold' : 'w-2.5 bg-white/20 hover:bg-white/40'}`} data-id="element-461" data-mp="29ot09nzirxjy" data-mpi={i} />)}
            </div>

            <button onClick={next} aria-label="Siguiente reseña" className="sm:hidden w-10 h-10 flex items-center justify-center rounded-full bg-dark border border-white/10 text-gray-400 hover:text-gold transition-colors" data-id="element-462" data-mp="a7hbhfdrrdbl">
              <ChevronRight className="w-5 h-5" data-id="element-463" data-mp="3sd42st0f4zvu" />
            </button>
          </div>
        </div>

        {/* Stats Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-464" data-mp="3ne0zpe4013qi">
          {stats.map((stat, index) => <div key={index} className="bg-dark/50 p-6 rounded-2xl border border-white/5 text-center" data-id="element-465" data-mp="3ilzlvnr6n4yd" data-mpi={index}>
              <div className="flex justify-center mb-4" data-id="element-466" data-mp="3dlldg4lo5szt">
                <stat.icon className="w-8 h-8 text-gold" data-id="element-467" data-mp="39nnngzk2r2vd" />
              </div>
              <div className="text-4xl font-black text-white mb-2" data-id="element-468" data-mp="34nj677bce443">
                {stat.data}
              </div>
              <p className="text-gray-400 text-sm mb-4 h-10" data-id="element-469" data-mp="2zphoappnkau7">{stat.desc}</p>
              <div className="bg-white/5 py-2 px-3 rounded-lg text-xs font-medium text-gold" data-id="element-470" data-mp="1f6nnzimc00fj">
                {stat.meaning}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}